module.exports = __webpack_public_path__ + "img/p2.787ababe.png";